import { html } from "lit-element";
import { StofwareElement } from "@stofloos/core/base/sw-element/index";

export class StofwareToastSimple extends StofwareElement {
	static get properties() {
		return {
			active: Boolean
		};
	}

	render() {
		// language=HTML
		return html`
			<style>
				:host {
					display: block;
					width: 250px;
					position: fixed;
					bottom: 20px;
					right: 0;
					padding: 25px;
					background-color: var(--app-white);
					box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
					text-align: center;
					will-change: transform;
					transform: translate3d(100%, 0, 0);
					transition-property: visibility, transform;
					transition-duration: 0.2s;
					visibility: hidden;

					font-weight: bold;
					font-size: 16px;
					border-left: 3px solid var(--app-accent);

					z-index: 999999;
				}

				:host([active]) {
					visibility: visible;
					transform: translate3d(0, 0, 0);
				}
			</style>
			<slot></slot>
		`;
	}
}

window.customElements.define("sw-toast-simple", StofwareToastSimple);
